import { md5 } from 'js-md5';

const base64KeyStr =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function base64Decode(input: string): Uint8Array {
  const cleanedInput = input.replace(/[^A-Za-z0-9+/=]/g, '').replace(/=/g, '');
  const bytes = Math.floor((cleanedInput.length / 4) * 3);
  const uarray = new Uint8Array(bytes);

  let enc1, enc2, enc3, enc4;
  let i = 0,
    j = 0;

  for (let k = 0; k < bytes; k += 3) {
    enc1 = base64KeyStr.indexOf(cleanedInput.charAt(j++));
    enc2 = base64KeyStr.indexOf(cleanedInput.charAt(j++));
    enc3 = base64KeyStr.indexOf(cleanedInput.charAt(j++));
    enc4 = base64KeyStr.indexOf(cleanedInput.charAt(j++));

    uarray[i++] = (enc1 << 2) | (enc2 >> 4);
    if (enc3 !== 64) uarray[i++] = ((enc2 & 15) << 4) | (enc3 >> 2);
    if (enc4 !== 64) uarray[i++] = ((enc3 & 3) << 6) | enc4;
  }

  return uarray;
}

function convertUint8ArrayToWordArray(u8Array: Uint8Array): {
  sigBytes: number;
  words: number[];
} {
  const words: number[] = [];
  for (let i = 0; i < u8Array.length; i += 4) {
    words.push(
      (u8Array[i] << 24) |
        (u8Array[i + 1] << 16) |
        (u8Array[i + 2] << 8) |
        u8Array[i + 3],
    );
  }
  return { sigBytes: words.length * 4, words };
}

function hexToBase64(hexstring: string): string {
  return btoa(
    hexstring
      .match(/\w{2}/g)
      ?.map((a) => String.fromCharCode(parseInt(a, 16)))
      .join('') || '',
  );
}

function generateLegacyHash(hashString: string): string {
  let hexHash = `${hashString.slice(0, 8)}-${hashString.slice(8, 12)}-3${hashString.slice(13, 16)}-`;
  const variantBin = parseInt(hashString[16], 16).toString(2).padStart(4, '0');
  const rfcVariantHex = parseInt(`10${variantBin.slice(2, 4)}`, 2).toString(16);
  hexHash += `${rfcVariantHex + hashString.slice(17, 20)}-${hashString.slice(20, 32)}`;
  return hexHash;
}

export function generateEmailHash(email: string): string | null {
  if (!email) return null;

  const emailLower = email.toLowerCase();
  const h1 = md5(emailLower);
  const h1Base64 = hexToBase64(h1);
  const h1Decoded = base64Decode(h1Base64);
  const h1WordArray = convertUint8ArrayToWordArray(h1Decoded);

  const wordArrayBuffer = new Uint8Array(
    h1WordArray.words.flatMap((word) => [
      (word >>> 24) & 0xff,
      (word >>> 16) & 0xff,
      (word >>> 8) & 0xff,
      word & 0xff,
    ]),
  );

  const h2 = md5(wordArrayBuffer);
  return generateLegacyHash(h2);
}

export function getFirstAndLastName(fullName?: string): {
  firstName?: string;
  lastName?: string;
} {
  if (!fullName) {
    return { firstName: undefined, lastName: undefined };
  }

  const nameParts = fullName.trim().split(/\s+/);

  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: '' };
  }

  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(' ');

  return { firstName, lastName };
}
